import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Magnetic } from "@/components/motion";
import SiteHeader from "@/components/SiteHeader";

export default function WorkspaceLogin() {
  const startGoogleLogin = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/workspace";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(
      redirectUrl
    )}`;
  };

  return (
    <div className="min-h-screen bg-[#0D1421] text-[#EEEEEF] flex flex-col">
      <SiteHeader />

      <div className="flex-1 grid lg:grid-cols-2">
        {/* Left: brand */}
        <div className="hidden lg:flex bg-[#010204] text-[#EEEEEF] p-14 items-center relative overflow-hidden grain">
          <div className="max-w-md relative z-10">
            <div className="text-[10px] uppercase tracking-[0.25em] font-semibold text-[#0E93EC] mb-6">
              — Pro Workspace
            </div>
            <h1 className="font-editorial text-6xl xl:text-7xl font-light tracking-tighter leading-[0.9]">
              Your leads.
              <br />
              <span className="italic">One inbox.</span>
            </h1>
            <p className="mt-8 text-[#C9C6C6] leading-relaxed">
              Every local job routed straight to your dashboard. Move a card
              from <b className="text-[#EEEEEF]">New</b> to{" "}
              <b className="text-[#EEEEEF]">Won</b> in one click. Notes,
              status, phone, all in one place.
            </p>
          </div>
        </div>

        {/* Right: sign in */}
        <div className="flex items-center justify-center p-8 md:p-14">
          <motion.div
            initial={{ opacity: 0, y: 24 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
            className="w-full max-w-md"
            data-testid="workspace-login-page"
          >
            <div className="text-[10px] uppercase tracking-[0.25em] font-semibold text-[#0E93EC] mb-6">
              — Sign in
            </div>
            <h2 className="font-editorial text-4xl sm:text-5xl font-light tracking-tighter text-[#EEEEEF] leading-[0.95] break-word-safe">
              Welcome back.
            </h2>
            <p className="mt-6 text-[#C9C6C6] leading-relaxed">
              Sign in to see your leads inbox, move deals through the pipeline,
              and manage your subscription.
            </p>

            <Magnetic strength={6}>
              <Button
                onClick={startGoogleLogin}
                className="group mt-10 w-full bg-[#0E93EC] hover:bg-[#0E2F5F] text-white rounded-none h-14 pl-6 pr-5 text-base font-medium"
                data-testid="google-signin-btn"
              >
                <svg viewBox="0 0 24 24" className="w-5 h-5 mr-3 shrink-0" aria-hidden="true">
                  <path fill="#fff" d="M12 11v2.8h4.6c-.2 1.2-1.3 3.5-4.6 3.5-2.8 0-5-2.3-5-5.1s2.2-5.1 5-5.1c1.6 0 2.7.7 3.3 1.3l2.2-2.1C15.9 5 14.1 4 12 4 7.6 4 4 7.6 4 12s3.6 8 8 8c4.6 0 7.7-3.2 7.7-7.8 0-.5-.1-.9-.1-1.2H12z"/>
                </svg>
                <span className="flex-1 text-left">Continue with Google</span>
                <span className="inline-flex items-center justify-center w-9 h-9 bg-[#0E93EC] transition-transform group-hover:translate-x-1">
                  <ArrowRight className="w-4 h-4" />
                </span>
              </Button>
            </Magnetic>

            <p className="mt-8 text-xs text-[#C9C6C6] leading-relaxed">
              By continuing, you agree to our Pro Agreement and Privacy
              Policy. New here?{" "}
              <Link to="/#contractors" className="text-[#0E93EC] underline">
                Sign up as a pro
              </Link>{" "}
              first for the full welcome.
            </p>
          </motion.div>
        </div>
      </div>
    </div>
  );
}
